<template>
    <div class="container">
        <terms></terms>
    </div>
</template> 

<script>

import Terms from '../components/SettsTerms'

export default {
    components: {Terms}
}

</script>